import React from "react";
import styled from "styled-components";
import { shallowEqual } from "react-redux";
import { useUscSelector } from "../../../../../redux/store";
import UscBasketItemWrapper from "../common/UscBasketItemWrapper";
import { useUscLabel } from "../../../../../utils/labels";
import { enableUscInsurance } from "../../../../../utils/settings";
import Text from "../../../../../../shared-components/toyota/styles/atoms/Text";
import { AemFmComponent } from "../../../../../../../common-deprecated/utils/aemFlexibilityMatrixUtils";
import { formatUscInsurancePriceAsObject } from "../../../../../utils/insuranceUtils";
import { getAemInsuranceRateFormat } from "../../../../../../../common-deprecated/settings/utils/financeSettingUtilsAem";
import DisclaimerIconWrapper from "../../DisclaimerIconWrapper";
import { UscDisclaimerType } from "../../../../../../shared-logic/types/UscCommonTypes";

const BasketInsuranceContainer = styled.div`
    display: flex;
    align-items: center;
`;

const BasketInsurance = (): JSX.Element | null => {
    const enableInsurance = useUscSelector(({ vehicle, uscSettings, commonSettings }) =>
        vehicle.result ? enableUscInsurance(commonSettings, uscSettings, vehicle.result, vehicle.type) : false,
    );
    const insurancePriceFormat = useUscSelector(({ commonSettings, vehicle }) =>
        getAemInsuranceRateFormat(commonSettings, AemFmComponent.Pdp, vehicle.type),
    );
    const { price, insuranceType } = useUscSelector(
        ({ insurance, commonSettings, uscSettings }) =>
            formatUscInsurancePriceAsObject(commonSettings, uscSettings, insurance.quote, insurancePriceFormat),
        shallowEqual,
    );
    const insuranceIsActive = useUscSelector((state) => !!state.insurance.quote);
    const showActiveInsurance = enableInsurance && insuranceIsActive;
    const titleInsuranceLabel = useUscLabel("uscBasketTitleInsurance");

    if (!showActiveInsurance) return null;

    return (
        <UscBasketItemWrapper title={titleInsuranceLabel}>
            <li>
                <BasketInsuranceContainer>
                    <Text variant="body-small-book">{insuranceType}</Text>
                    <DisclaimerIconWrapper type={UscDisclaimerType.Insurance} />
                </BasketInsuranceContainer>

                <Text variant="body-small-book">
                    <span dangerouslySetInnerHTML={{ __html: price }} />
                </Text>
            </li>
        </UscBasketItemWrapper>
    );
};

export default BasketInsurance;
